/** Sample allpet catalog used by Vendor PO try-form (16 products). */
export type VendorPoCatalogItem = {
  inventory_id: number;
  item_name: string;
  upc_code: number;
  price: number;
  cost: number;
  quantity_on_hand: number;
  ytd_sold: number;
  lead_time_days: number;
  cycle_stock: number;
  service_level: number;
  current_month_to_date: number;
  last_month: number;
  previousYear: number;
};

export const VENDOR_PO_PRODUCTS: VendorPoCatalogItem[] = [
  {
    inventory_id: 1,
    item_name: "LAY MASH  50",
    upc_code: 400000000053,
    price: 22.59,
    cost: 15.62,
    quantity_on_hand: 178,
    ytd_sold: 2166,
    lead_time_days: 0,
    cycle_stock: 50,
    service_level: 99,
    current_month_to_date: 309,
    last_month: 179,
    previousYear: 195,
  },
  {
    inventory_id: 2,
    item_name: "LAY MASH  25",
    upc_code: 400000000060,
    price: 12.99,
    cost: 8.36,
    quantity_on_hand: 47,
    ytd_sold: 354,
    lead_time_days: 0,
    cycle_stock: 25,
    service_level: 99,
    current_month_to_date: 38,
    last_month: 32,
    previousYear: 37,
  },
  {
    inventory_id: 3,
    item_name: "CHICK STARTER  50",
    upc_code: 400000000077,
    price: 24.49,
    cost: 16.8,
    quantity_on_hand: 92,
    ytd_sold: 1180,
    lead_time_days: 1,
    cycle_stock: 40,
    service_level: 99,
    current_month_to_date: 140,
    last_month: 95,
    previousYear: 110,
  },
  {
    inventory_id: 4,
    item_name: "GAMEBIRD CRUMBLE  40",
    upc_code: 400000000084,
    price: 28.99,
    cost: 19.4,
    quantity_on_hand: 61,
    ytd_sold: 640,
    lead_time_days: 2,
    cycle_stock: 30,
    service_level: 98,
    current_month_to_date: 72,
    last_month: 55,
    previousYear: 60,
  },
  {
    inventory_id: 5,
    item_name: "HORSE SWEET FEED  50",
    upc_code: 400000000091,
    price: 19.99,
    cost: 13.25,
    quantity_on_hand: 210,
    ytd_sold: 2890,
    lead_time_days: 0,
    cycle_stock: 60,
    service_level: 99,
    current_month_to_date: 320,
    last_month: 250,
    previousYear: 275,
  },
  {
    inventory_id: 6,
    item_name: "DOG KIBBLE ADULT  40",
    upc_code: 400000000107,
    price: 34.5,
    cost: 22.1,
    quantity_on_hand: 88,
    ytd_sold: 980,
    lead_time_days: 1,
    cycle_stock: 35,
    service_level: 99,
    current_month_to_date: 105,
    last_month: 80,
    previousYear: 90,
  },
  {
    inventory_id: 7,
    item_name: "CAT LITTER CLUMP  25",
    upc_code: 400000000114,
    price: 14.75,
    cost: 8.9,
    quantity_on_hand: 130,
    ytd_sold: 1540,
    lead_time_days: 0,
    cycle_stock: 45,
    service_level: 97,
    current_month_to_date: 160,
    last_month: 120,
    previousYear: 135,
  },
  {
    inventory_id: 8,
    item_name: "BIRDSEED MIX  20",
    upc_code: 400000000121,
    price: 11.49,
    cost: 6.75,
    quantity_on_hand: 75,
    ytd_sold: 720,
    lead_time_days: 0,
    cycle_stock: 25,
    service_level: 98,
    current_month_to_date: 70,
    last_month: 58,
    previousYear: 65,
  },
  {
    inventory_id: 9,
    item_name: "RABBIT PELLETS  50",
    upc_code: 400000000138,
    price: 21.25,
    cost: 14.1,
    quantity_on_hand: 54,
    ytd_sold: 510,
    lead_time_days: 1,
    cycle_stock: 20,
    service_level: 99,
    current_month_to_date: 48,
    last_month: 40,
    previousYear: 44,
  },
  {
    inventory_id: 10,
    item_name: "FISH FOOD FLAKE  5",
    upc_code: 400000000145,
    price: 9.99,
    cost: 5.4,
    quantity_on_hand: 160,
    ytd_sold: 1880,
    lead_time_days: 0,
    cycle_stock: 50,
    service_level: 96,
    current_month_to_date: 190,
    last_month: 150,
    previousYear: 165,
  },
  {
    inventory_id: 11,
    item_name: "GOAT MINERAL  25",
    upc_code: 400000000152,
    price: 17.8,
    cost: 11.2,
    quantity_on_hand: 39,
    ytd_sold: 290,
    lead_time_days: 2,
    cycle_stock: 15,
    service_level: 98,
    current_month_to_date: 28,
    last_month: 22,
    previousYear: 25,
  },
  {
    inventory_id: 12,
    item_name: "PIG GROWER  50",
    upc_code: 400000000169,
    price: 23.4,
    cost: 15.9,
    quantity_on_hand: 70,
    ytd_sold: 860,
    lead_time_days: 1,
    cycle_stock: 30,
    service_level: 99,
    current_month_to_date: 95,
    last_month: 70,
    previousYear: 80,
  },
  {
    inventory_id: 13,
    item_name: "SHEEP GRAIN  40",
    upc_code: 400000000176,
    price: 20.15,
    cost: 13.55,
    quantity_on_hand: 44,
    ytd_sold: 410,
    lead_time_days: 1,
    cycle_stock: 20,
    service_level: 98,
    current_month_to_date: 42,
    last_month: 35,
    previousYear: 38,
  },
  {
    inventory_id: 14,
    item_name: "ALFALFA CUBES  40",
    upc_code: 400000000183,
    price: 26.75,
    cost: 18.2,
    quantity_on_hand: 33,
    ytd_sold: 360,
    lead_time_days: 2,
    cycle_stock: 18,
    service_level: 97,
    current_month_to_date: 30,
    last_month: 28,
    previousYear: 32,
  },
  {
    inventory_id: 15,
    item_name: "CORN CRACKED  50",
    upc_code: 400000000190,
    price: 15.99,
    cost: 9.85,
    quantity_on_hand: 145,
    ytd_sold: 1720,
    lead_time_days: 0,
    cycle_stock: 55,
    service_level: 99,
    current_month_to_date: 180,
    last_month: 140,
    previousYear: 155,
  },
  {
    inventory_id: 16,
    item_name: "OATS WHOLE  50",
    upc_code: 400000000206,
    price: 16.49,
    cost: 10.4,
    quantity_on_hand: 102,
    ytd_sold: 990,
    lead_time_days: 0,
    cycle_stock: 40,
    service_level: 99,
    current_month_to_date: 110,
    last_month: 85,
    previousYear: 95,
  },
];

export function vendorPoItemsPayload(
  selectedId: number,
  quantityOnHand: number,
): Record<string, unknown>[] {
  return VENDOR_PO_PRODUCTS.map((p) => {
    const { item_name: _name, ...rest } = p;
    return {
      ...rest,
      quantity_on_hand: p.inventory_id === selectedId ? quantityOnHand : p.quantity_on_hand,
    };
  });
}
